module.exports = __webpack_public_path__ + "static/sara-1450652edd4061e8111e2c1bc8ca41fc.png";